import { Link } from 'react-router-dom';
import { getPopularArticles } from '@/mocks/articles';
import { getCategoryBySlug } from '@/mocks/categories';

export default function HotContentSection() {
  const popularArticles = getPopularArticles(6);

  return (
    <section className="py-16 md:py-24 bg-background-100/60">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门内容推荐
            </h2>
            <p className="text-foreground-600 text-sm">精选全网最受欢迎的视频内容</p>
          </div>
          <Link
            to="/category/gaoxiao"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {popularArticles.map((article) => {
            const category = getCategoryBySlug(article.categorySlug);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={article.thumbnail}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/70 text-background-50 text-xs font-medium">
                    {article.duration}
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    {category && (
                      <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">
                        {category.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-500">{article.publishDate}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(1)}万`
                        : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i>
                      {article.likes >= 10000
                        ? `${(article.likes / 10000).toFixed(1)}万`
                        : article.likes}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <Link
            to="/category/gaoxiao"
            className="flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}